import React from 'react';
import { PlusCircle } from 'lucide-react';

/** Lớp do import học sinh tạo (hoặc sẽ tạo, ở bước xem trước) cho năm học hiện tại */
export interface ImportNewClass {
  id?: string | null;
  name: string;
  grade?: string | null;
  school_year: string;
  rows: number[];
}

const ImportNewClasses: React.FC<{ classes: ImportNewClass[]; created?: boolean }> = ({ classes, created = false }) => {
  if (classes.length === 0) return null;

  return (
    <div className="bg-indigo-50 border border-indigo-200 rounded-md p-4">
      <h4 className="text-sm font-medium text-indigo-800 mb-2 flex items-center">
        <PlusCircle className="h-4 w-4 mr-1" />
        {created ? 'Đã tạo' : 'Sẽ tạo'} {classes.length} lớp mới cho năm học {classes[0].school_year}:
      </h4>
      <ul className="text-sm text-indigo-700 space-y-1">
        {classes.map((item) => (
          <li key={item.name}>
            Lớp {item.name}
            {item.grade ? ` — Khối ${item.grade}` : ''} ({item.rows.length} học sinh)
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ImportNewClasses;
